import { useQueryBuilder, useMutationBuilder } from "src/query/useBuilders";
import { customFieldsApi } from "src/services/settings/customFields";
import {
  CUSTOM_FIELD_CREATE,
  CUSTOM_FIELD_DELETE,
  CUSTOM_FIELD_ORDER,
  CUSTOM_FIELD_UPDATE,
  CUSTOM_FIELDS,
} from "../queryKeys";
import { CreateCustomFieldRequest, CustomField, UpdateCustomFieldInput } from "src/types/settings/customFields";


export const useCustomFieldsQuery = () => {
  return useQueryBuilder([CUSTOM_FIELDS], async () => {
    const data = await customFieldsApi.fetchCustomFields();
    return data as CustomField[];
  });
};

export const useCreateCustomFieldMutation = () => {
  return useMutationBuilder<CustomField[], CreateCustomFieldRequest>(
    [CUSTOM_FIELD_CREATE],
    (data) => customFieldsApi.createCustomField(data),
    [CUSTOM_FIELDS],
  );
};

export const useUpdateCustomField = () => {
  return useMutationBuilder<CustomField[], UpdateCustomFieldInput>(
    [CUSTOM_FIELD_UPDATE],
    ({ id, data }) => customFieldsApi.updateCustomField(id, data),
    [CUSTOM_FIELDS],
  );
};

export const useDeleteCustomField = () => {
  return useMutationBuilder<CustomField[], string>(
    [CUSTOM_FIELD_DELETE],
    (id: string) => customFieldsApi.deleteCustomField(id),
    [CUSTOM_FIELDS],
  );
};

export const useReorderCustomFields = () => {
  return useMutationBuilder<CustomField[], string[]>(
    [CUSTOM_FIELD_ORDER],
    (ids: string[]) => customFieldsApi.orderCustomFields(ids),
    [CUSTOM_FIELDS],
  );
};
